import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbFriends } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { usePlanActions, usePlanShowUpdateCompanionsDialog } from "@/stores/use-plan-table";

import UpdateCompanionsDialog from "./UpdateCompanionsDialog";

function UpdateCompanionsComp() {
    const { t } = useTranslation();
    const showUpdateCompanionsDialog = usePlanShowUpdateCompanionsDialog();
    const { updateShowUpdateCompanionsDialog } = usePlanActions();
    const onClose = () => {
        updateShowUpdateCompanionsDialog();
    };
    return (
        <CommonPopup
            title={t("buttons.updateCompanions")}
            icon={TbFriends}
            open={!!showUpdateCompanionsDialog}
            size="sm"
            onClose={onClose}
        >
            <>
                <Alert severity="info">
                    Yolcu ile beraber transfer işlemlerini gerçekleştirecek kişilerin bilgisini doldurunuz.
                </Alert>
                <UpdateCompanionsDialog />
            </>
        </CommonPopup>
    );
}

export default UpdateCompanionsComp;
